import { createContext, useContext } from 'react';

import useInsightsGroupTypeManagement from 'components/insights/hooks/useInsightsGroupTypeManagement';
import GroupType from 'models/GroupType';
import Profile from 'models/Profile';

export type InsightsDashboardContextType = {
  profile: Profile;
  predecessorGroupTypes: GroupType[];
  groupTypes: GroupType[];
  onTabChange: (groupType: GroupType) => void;
};

type Config = {
  preferenceKey: string;
  useSelectedGroupType: () => GroupType | undefined;
  useActions: () => {
    setSelectedGroupType: (groupType: GroupType | undefined) => void;
    resetFilters: () => void;
  };
  Page: React.ComponentType;
};

export default function createInsightsDashboardContainer({
  preferenceKey,
  useSelectedGroupType,
  useActions,
  Page,
}: Config) {
  const Context = createContext<InsightsDashboardContextType>({
    profile: {} as Profile,
    predecessorGroupTypes: [],
    groupTypes: [],
    onTabChange: () => {},
  });

  const useDashboardContext = () => useContext(Context);

  const Container = () => {
    const selectedGroupType = useSelectedGroupType();
    const { setSelectedGroupType, resetFilters } = useActions();

    const { profile, predecessorGroupTypes, groupTypes, handleTabChange } = useInsightsGroupTypeManagement({
      preferenceKey,
      setSelectedGroupType,
      resetFilters,
      selectedGroupType,
    });

    return (
      <Context
        value={{
          profile,
          predecessorGroupTypes,
          groupTypes,
          onTabChange: handleTabChange,
        }}>
        {predecessorGroupTypes.length > 0 && selectedGroupType && <Page />}
      </Context>
    );
  };

  return { Context, useDashboardContext, Container };
}
